import apiClient from '../client.js'

async function createStatus(scope, payload) {
  return apiClient.post(`/${scope}/tickets/statuses`, payload)
}

async function updateStatus(scope, id, patch) {
  return apiClient.patch(`/${scope}/tickets/statuses/${id}`, patch)
}

async function deleteStatus(scope, id) {
  return apiClient.delete(`/${scope}/tickets/statuses/${id}`)
}

class StatusService {
  create = {
    /**
     * Create a status under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {object} payload
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async status(scope, payload) {
      return createStatus(scope, payload)
    },
  }

  update = {
    /**
     * Update one status under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @param {object} patch
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async status(scope, id, patch) {
      return updateStatus(scope, id, patch)
    },
  }

  delete = {
    /**
     * Delete one status under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async status(scope, id) {
      return deleteStatus(scope, id)
    },
  }
}

export default new StatusService()
